import { fetcher } from '@commenda/utils';

export type SignedUrlForPutResponse = {
  // The URL associated with this file to save in the database for future GET requests.
  hostedUrl: string;
  // URL to POST to to push this file to S3.
  signedUrl: string;
  // URL to GET from to read this file. Expires in 24 hours.
  // Required because otherwise you can't download a file until it's stored in our file system.
  // signedGetRequest: string;
};

type SignedUrlForPutRequest = {
  fileName: string;
  companyId?: number;
};

export const getSignedUrlForPut = async (
  sanitizedFileName: string,
  companyId: number | undefined,
  nextAuthToken?: string
): Promise<SignedUrlForPutResponse | null> => {
  try {
    const req: SignedUrlForPutRequest = {
      fileName: sanitizedFileName,
    };
    if (companyId) {
      req.companyId = companyId;
    }

    const res = await fetcher(
      `s3/signedUrlForPut`,
      {
        method: 'POST',
        body: req,
      },
      nextAuthToken || undefined
    );

    if (!res.ok) {
      console.error(await res.json());
      return null;
    }

    const data = await res.json();

    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
